import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aPVyw"), parcelRequire.load("9f8mp"), parcelRequire.load("ccpeN"), parcelRequire.load("97gFA"), parcelRequire.load("4ooGe"), parcelRequire.load("eYc7M"), parcelRequire.load("k0Vga"), parcelRequire.load("dZMz1"), parcelRequire.load("c0VSK"), parcelRequire.load("lfyA4"), parcelRequire.load("8aknZ"), parcelRequire.load("3vA1P")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aPVyw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("ccpeN")} />
  <link rel="modulepreload" href={parcelRequire.resolve("97gFA")} />
  <link rel="modulepreload" href={parcelRequire.resolve("4ooGe")} />
  <link rel="modulepreload" href={parcelRequire.resolve("eYc7M")} />
  <link rel="modulepreload" href={parcelRequire.resolve("k0Vga")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dZMz1")} />
  <link rel="modulepreload" href={parcelRequire.resolve("c0VSK")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lfyA4")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8aknZ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3vA1P")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
